import { tns } from 'tiny-slider/src/tiny-slider'

class PressCarousel {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniCarousel()
    }

    _iniCarousel() {
        this.carouselElem = this.element.querySelector('.s-press-teaser__items')

        this.carousel = tns({
            container: this.carouselElem,
            items: 3,
            slideBy: 1,
            nav: false,
            mouseDrag: true,
            loop: false,
            controlsPosition: 'bottom',
            controlsText: ['', ''],
            prevButton: this.element.querySelector('.s-press-teaser__controls__prev'),
            nextButton: this.element.querySelector('.s-press-teaser__controls__next'),
            edgePadding: 0,
            gutter: 26,
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                },
                1024: {
                    items: 3,
                },
            },
        })
    }
}

export default PressCarousel
